import { branch, renderNothing } from 'recompose'

import { withMeta } from 'i18n/utils'
import { loadGoogleAPI } from 'map/actions'
import { googleAPIReadySelector } from 'map/selectors'
import { fetchLocation } from 'sfproxy/actions'
import DownloadApp from 'shared/components/DownloadApp'
import { locationSelector } from 'sfproxy/selectors'
import { loadOnMount } from 'shared/hoc'
import Marker from 'shared/components/ShowStreetViewMarker'

import Avaliability from './Availability'
import Tickets from './Tickets'
import Promotions from './Promotions'
import Services from 'car-parks/components/services'
import AccessModes from 'car-parks/components/accessModes/index'
import Prices from './Prices'
import Information from './Information'
import Content from './Content'
import Map from './CarParkMap'

import '../styles/car-parks.scss'

const CarPark = ({ locationId, location }) => (
    <div id="car-park" className="car-park content">
        <div className="map">
            <Map locationId={locationId}>
                <Marker />
            </Map>
        </div>

        <Content locationId={locationId} sfLocationId={locationId} />

        <div className="container-fluid info">
            <div className="container">
                <div className="card-group">
                    <AccessModes locationId={locationId} />
                    <Prices locationId={locationId} sfLocationId={locationId} />
                    <Information locationId={locationId} />
                </div>
            </div>
        </div>

        {location && <Avaliability data={location.siteUsage} />}
        <Tickets grsId={location.grsId} />
        <Services locationId={locationId} />
        <Promotions id={locationId} />
        <DownloadApp />
    </div>
)

export default compose(
    connect(
        createStructuredSelector({
            location: locationSelector,
            apiReady: googleAPIReadySelector,
        }),
        { fetchLocation, loadGoogleAPI }
    ),
    loadOnMount('fetchLocation', ({ locationId }) => [locationId]),
    branch(props => !props.location, renderNothing),
    withMeta(({ location }) => location.meta)
)(CarPark)
